
import React, { useEffect,useState } from 'react';
import { Layout, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch, DatePicker, Divider } from 'antd';
import { FormOutlined, DownloadOutlined, DeleteOutlined,PlusOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, appIdentifier, dateFormat, deleteDataWithToken, editDataWithToken, getDataWithToken, getLocal, globalUrlBare } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
import moment from 'moment';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة البحوث المرسلة';

const  MngThesis = ()=> {
    const navigate = useNavigate();
    const [addInfoForm] = Form.useForm()
    const [editInfoForm] = Form.useForm()

    const [addInfoVisible, setAddInfoVisible] = useState(false);
    const [editInfoVisible, setEditInfoVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [infoFormInfo, setInfoFormInfo] = useState(null)
    const [infos, setInfos] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [certificates, setcertificates] = useState([])
    const [scintificTitles, setscintificTitles] = useState([])
    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getThesis(current,pageSize)
      };


      const onAddClose = () => {
        setAddInfoVisible(false);
        setSelectedInfo(null)
        addInfoForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditInfoVisible(false);
        setSelectedInfo(null)
        editInfoForm.resetFields()
        
      };

   
   

      const getThesis = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`dissertations?populate=deep,4&pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setInfos(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const getCertificates = (current=1,pageSize=25)=>{
        getDataWithToken(`certificates`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setcertificates(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const getScintificTitles = ()=>{
        getDataWithToken(`scintific-titles`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setscintificTitles(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const addInfo = (data)=>{
        setAddLoading(true)
        addDataWithToken(`infos`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة التدريسي بنجاح');
            getThesis();
            addInfoForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`infos/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف التدريسي بنجاح');
                            getThesis();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareGetDetails = (data)=>{
            console.log(data)
            setSelectedInfo(data)
            // const newData = {
            //     ...data,
            //     birthdate:moment(data?.birthdate),
            //     start_date:moment(data?.start_date),
            //     certificate:data?.certificate?.id,
            //     scintific_title:data?.scintific_title?.id
            // }
            // editInfoForm.setFieldsValue(newData)
            setAddInfoVisible(true)
        }

        const editInfo = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`infos/${selectedInfo?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل التدريسي بنجاح');
                        getThesis();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getThesis();
       getCertificates();
       getScintificTitles();
      }, [])

      const returnCertTitle = (value)=>{
        var title = '';
        switch (value) {
            case 'master':
                title = 'الماجستير'
                break;

            case 'doctor':
                title = 'الدكتوراه'
                break;
            
        
            default:
                break;
        }
        return title
      }


      const returnStatusTitle = (value)=>{
        var title = '';
        switch (value) {
            case 'accepted_no_notes':
                title = <Tag color={'green'} >صالح للمناقشة بدون ملاحظات</Tag>
                break;

            case 'accepted_with_notes':
                title = <Tag color={'green'} >صالح للمناقشة - مع عرض الملاحظات المرفقة على لجنة المناقشة (حصراً)</Tag> 
                break;

            case 'rejected':
                title = <Tag color={'red'}  >لا تصلح للمناقشة - مع ذكر الاسباب المبررة الموجبة لرفض الرسالة / الاطروحة</Tag> 
                break;
            
        
            default:
                break;
        }
        return title
        
      }
      
    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                title={` تفاصيل الاطروحة / الرسالة  ( ${selectedInfo?.title} ) \xa0\xa0\xa0\xa0\xa0 \xa0\xa0\xa0\xa0\xa0 الطالب (${selectedInfo?.student_name}) `}
                placement="left"
                closable={false}
                onClose={onAddClose}
                visible={addInfoVisible}
                width={window.innerWidth > 900 ? 700 :  350}
            >

                <Divider orientation="right" orientationMargin="0" >الملفات المرسلة للمقوم العلمي</Divider>
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>
                    {
                        selectedInfo?.sender_attachment?.map((item, index) => {
                            return(
                                <Button  style={{marginLeft:16, marginBottom:16}} href={`${globalUrlBare}${item?.url}`} type="primary" shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                    تنزيل المرفق  {`\xa0\xa0\xa0\xa0\xa0 ${index+1}`}
                                </Button>
                            )
                            
                        })
                    }
                    
                        
                </Row>

                <Divider orientation="right" orientationMargin="0" > المرفقات المرفوعة من قبل المقوم العلمي </Divider>
                
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>

                    {
                        

                        selectedInfo?.teacher_attachment?.length>0?selectedInfo?.teacher_attachment?.map((item, index) => {
                            return(
                                <Button  style={{marginLeft:16, marginBottom:16}} href={`${globalUrlBare}${item?.url}`} type="primary" shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                    تنزيل المرفق  {`\xa0\xa0\xa0\xa0\xa0 ${index+1}`}
                                </Button>
                            )
                            
                        })
                        :
                        <h4>لا يوجد مرفقات</h4>
                    }
                    
                        
                </Row>

                <Divider orientation="right" orientationMargin="0" > الاستمارات الموقعة من قبل المقوم العلمي </Divider>
                
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>

                    {

                        selectedInfo?.stamped_promise_attachement?.length>0?selectedInfo?.stamped_promise_attachement?.map((item, index) => {
                            return(
                                <Button  style={{marginLeft:16, marginBottom:16}} href={`${globalUrlBare}${item?.url}`} type="primary" shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                 تنزيل استمارة تعهد السلامة الفكرية الموقعة   
                                </Button>
                            )
                            
                        })
                        :
                        <h4>لم بتم رفع استمارة تعهد السلامة الفكرية</h4>
                    }
                    {`\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 | \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0`}

                    {

                    selectedInfo?.stamped_rate_attachement?.length>0?selectedInfo?.stamped_rate_attachement?.map((item, index) => {
                        return(
                            <Button  style={{marginLeft:16, marginBottom:16}} href={`${globalUrlBare}${item?.url}`} type="primary" shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                تنزيل استمارة المقوم العلمي الموقعة  
                            </Button>
                        )
                        
                    })
                    :
                    <h4>لم بتم رفع استمارة المقوم العلمي الموقعة</h4>
                    }
                    
                        
                </Row>

                <Divider orientation="right" orientationMargin="0" >حالة التقييم</Divider>
                
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>

                         <Space>
                            {returnStatusTitle(selectedInfo?.decision_status) }
                        </Space>

                </Row>

                <Divider orientation="right" orientationMargin="0" >ملاحظات التقييم</Divider>
                
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>

                         <Space>
                            {returnStatusTitle(selectedInfo?.decision_details) }
                        </Space>

                </Row>

               

                        
                        
              
                
            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'MngThesis'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={infos}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                        
                    >

                    

                        <Column title="اسم الطالب"  width="200px" key="student_name" fixed="left" dataIndex="student_name" />
                        <Column title="عنوان الرسالة \ الاطروحة"  width="200px" key="title"  dataIndex="title" />
                        

                        <Column title="الشهادة"  width="200px" key="certificate" 
                            render={(text, record) => (
                                <Space>
                                    {returnCertTitle(record?.student_certificate) }
                                </Space>
                                
                            )}
                        />
                        <Column title="الحالة"  width="400px" key="decision_status" 
                            render={(text, record) => (
                                <Space>
                                    {returnStatusTitle(record?.decision_status) }
                                </Space>
                                
                            )}
                        />


                        <Column title="الاختصاص العام للرسالة \ الاطروحة"  width="200px" key="dissertation_general_sepcialization" dataIndex="dissertation_general_sepcialization" />
                        <Column title="الاختصاص الدقيق للرسالة \ الاطروحة"  width="200px" key="dissertation_specific_sepcialization" dataIndex="dissertation_specific_sepcialization" />

                        

                        
                        <Column title="الجامعة"  width="200px" key="university" 
                            render={(text, record) => (
                                <Space>
                                    {record?.university?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الكلية"  width="200px" key="college" 
                            render={(text, record) => (
                                <Space>
                                    {record?.college?.title}
                                </Space>
                                
                            )}
                        />
                        

                        <ColumnGroup title={<h1 style={{backgroundColor:'#e6f7ff', paddingTop:16, paddingBottom:16}}>معلومات التدريسي </h1>}    >
                            <Column  title="اسم التدريسي"  width="200px" key="teacher_name" 
                                render={(text, record) => (
                                    <Space>
                                        {record?.teacher?.teacher_info?.teacher_name}
                                    </Space>
                                    
                                )}
                            />

                            <Column  title="الاختصاص"  width="200px" key="specialization" 
                                render={(text, record) => (
                                    <Space>
                                        {record?.teacher?.teacher_info?.specialization}
                                    </Space>
                                    
                                )}
                            />

                            <Column title="الاختصاص الدقيق"  width="200px" key="delicate_specialization" 
                                render={(text, record) => (
                                    <Space>
                                        {record?.teacher?.teacher_info?.delicate_specialization}
                                    </Space>
                                    
                                )}
                            />

                            <Column title="البريد الالكتروني"  width="200px" key="teacher_email" 
                                render={(text, record) => (
                                    <Space>
                                        {record?.teacher?.teacher_info?.email}
                                    </Space>
                                    
                                )}
                            />

                            <Column title="رقم الهاتف"  width="200px" key="teacher_phone" 
                                render={(text, record) => (
                                    <Space>
                                        {record?.teacher?.teacher_info?.phone}
                                    </Space>
                                    
                                )}
                            />

                           
                        </ColumnGroup>

                       
                       
                        <Column title="تاريخ اخر تعديل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { moment(record?.updatedAt).format(dateFormat) }
                                </Space>
                                
                            )}
                        />
                        <Column title="تم التعديل من قبل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { record?.sender?.fname||''}
                                </Space>
                                
                            )}
                        />

                        
                        {
                            localUserType==='depart'&&
                            
                            <Column title="التفاصيل"  width="200px" key="status" 
                                fixed='right'
                                render={(text, record) => (
                                    <Space>
                                    <Button onClick={()=> prepareGetDetails({id:record?.id,...record}) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<FormOutlined />} size={20}>
                                        عرض التفاصيل
                                    </Button>

                                   
                                    </Space>
                                    
                                )}
                            />

                        }
                         
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngThesis




